export class ExternalResponse {
    public code!: number;
    public message!: string;
}
